(() => {
  if (window.feblilacCollectionReady) return;
  window.feblilacCollectionReady = true;

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('.fl-load-more');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;

    const originalLabel = link.textContent;
    link.setAttribute('aria-busy', 'true');
    link.textContent = 'Loading…';

    try {
      const response = await fetch(link.href, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(`Request failed: ${response.status}`);

      const html = await response.text();
      const documentNext = new DOMParser().parseFromString(html, 'text/html');
      const grid = document.querySelector('#product-grid');
      const incomingGrid = documentNext.querySelector('#product-grid');

      if (!grid || !incomingGrid) throw new Error('Product grid was not found');

      incomingGrid.querySelectorAll(':scope > li').forEach((item) => {
        item.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
        item.removeAttribute('data-cascade');
        item.removeAttribute('style');
        grid.appendChild(item);
      });

      const nextLink = documentNext.querySelector('.fl-load-more');
      if (nextLink) {
        link.href = nextLink.href;
        link.textContent = originalLabel;
        link.removeAttribute('aria-busy');
      } else {
        link.closest('.fl-collection-pagination')?.remove();
      }

      grid.dispatchEvent(new CustomEvent('feblilac:products-appended', { bubbles: true }));
    } catch (error) {
      link.textContent = originalLabel;
      link.removeAttribute('aria-busy');
      window.location.assign(link.href);
    }
  });
})();
